import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";
import {persistStore} from "../../stores/PersistStore";
import DidYouKnow from "../elements/DidYouKnow";
import {profileChoices, sections} from "../../assets/settings";
import firebase from 'firebase';

// let hasRendered = false;

function Welcome(props) {
    const {store, state, color, index, progress} = props;
    const {persistStore} = store;

    if (state === 'N/A') {
        return null;
    }

    function setChoice(choice) {
        persistStore.setProfile(choice);
    }

    const buttonMode = () => {
        return (<Fragment>
            <div className={'did-you'}>
                {didYouKnow()}
            </div>
            <div className={'welcome-instructions'}>
                <h2>Let’s get started!</h2>
                <p>My Primary Affiliation with UC Berkeley is…</p>
                <i>(If you would like to skip the question, select “Prefer Not To Answer”)</i>

            </div>
            {Object.keys(profileChoices).map((k) =>
                <div key={k}>
                    <button className={'intro-choice'} onClick={() => {
                        setChoice(k)
                    }}>{profileChoices[k]}
                    </button>
                </div>
            )}
        </Fragment>);
    };

    const introQuestion = () => {
        if (!persistStore.noSelection) {
            return (<div className={'welcome-profile-selected'}>
                You chose: {profileChoices[persistStore.profile]}
                <button className={'close'} onClick={() => setChoice('NO_SELECTION')}>x</button>
            </div>);
        } else {
            return buttonMode();
        }
    };

    //console.log(`STATE ${state} PROGRESS ${progress}  profileSet: ${persistStore.profileSet}`);

    const normProgress = (animFrom, animTo) => {
        if (progress <= animFrom) return 0;
        if (progress >= animTo) return 1;
        return (progress - animFrom) / (animTo - animFrom);
    };

    const gateImage = (zIndex, file) => {
        if (state === 'OFF-SCREEN') {
            return null;
        }
        // hasRendered = true;
        const style = {width: '100vw'};
        let dim = normProgress(0.4, 0.5);
        if (dim >= 1) {
            return null;
        }
        const along = normProgress(0.2, 0.5) * 250;

        const startWidth = 110;
        const topOffset = -7;
        let width = along + startWidth;
        let top = along * 0.75 + 100;
        style.width = `${width}vw`;
        style.left = `${50 - width / 2}vw`;
        style.top = `${topOffset + 50 - top / 2}vw`;
        style.opacity = 1 - dim;
        style.pointerEvents = 'none';
        style.zIndex = zIndex;
        return (<img className={'gate-img'} style={style}
                     src={`img/sather/${file}`}
                     alt={"rendering of Sather Gate"}/>);
    };

    const didYouKnow = () => {
        return (<DidYouKnow store={store} bubbleOnLeft={true} color={color}>
            <h3>Why are we asking this?</h3>
            <p>Telling us about yourself will customize some of the questions you get asked. If you would prefer to skip this question, that’s completely ok, just keep scrolling.</p>
        </DidYouKnow>);
    };


    const toc = () => {
        return (
            <div id={"toc"} className={'toc'}>
                {sections.map(({key, title, color, subtitle}) =>
                    <a key={`section_${key}`} className={'toc-section'} style={{background: color}}
                       href={`#${key}_header`}><h3>{title}</h3>
                        <p>{subtitle}</p>
                    </a>
                )}
            </div>);
    };

    const style = {};
    if (!store.interactionsStore.mobileMode) {
        style.height = '200vw'//(persistStore.profileSet) ? '100vw' : '100vh'
    }

    return (
        <div className={'Welcome'} style={style}>
            {gateImage(2, 'sather gate.svg')}
            {gateImage(0, 'sather gate-base.svg')}
            <div className={'welcome-spacer'}/>
            <div className={'welcome-text'}>
                Welcome to UC Berkeley’s Campus Planning Virtual Open House
            </div>
            <div className={'come-on-in'} style={{background: color + 'aa'}}>
                <h2>Come on in!</h2>
                <p>
                  This virtual open house is a special opportunity to help shape the UC Berkeley of tomorrow. A multiyear process is underway to update our two primary campus planning documents: the Long Range Development Plan and the Campus Master Plan.
                </p>

                <p>
                  Today, we're sharing results from the first phase of our work to update these guiding campus plans - work that students, faculty, and staff across the campus have been a part of. We want to share what we've learned, and we want you to contribute your thoughts and ideas. There's still a ways to go in updating these plans - and we want your help.
                </p>
                <h3>
                  Keep scrolling to continue! This virtual open house is optimized for desktop viewing.
                </h3>
            </div>
            <div className={'intro-question'}>
                <div className={'intro-section'}>
                    {introQuestion()}
                </div>
                <div className={'intro-section'}>
                    <div className={'orientation'}>
                        <div className={'instructions'}>
                            <h3>Our virtual open house has 7 stations, all accessed by scrolling down this page.</h3>
                            <p>
                              Each station discusses a different campus planning topic.
                            </p>
                            <p>
                              Planning for change in one area of the campus can affect others or have secondary consequences on other campus goals. That’s why we’ll be taking an integrated planning approach - that means considering how one topic area, like transportation/mobility, relates to other topic areas like land use and climate resilience.
                            </p>
                            <p>
                                After each station, we’ll ask you a question or two. We want to hear your thoughts and ideas!
                            </p>
                            <p>
                                You can jump between stations by using the navigation panel on the left.
                            </p>
                        </div>

                        {toc()}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default observer(Welcome);
